<template>
    <div>
        <span class="v-label theme--light mb-2">{{label}} ({{config.templateSettings && config.templateSettings.name ? (config.templateSettings.props.length ? (templateSettings.props.length + ' ' + $translate('pcs')) : $translate('Headline set')) : $translate('None')}})</span>
        <v-btn class="float-right zoezi-button-thin" color="zoezi-edit-color" text @click="showDialog=true">{{$translate('Edit')}}</v-btn>

        <v-dialog
            v-model="showDialog"
            max-width="850"
            scrollable
        >
            <v-card>
                <v-card-title class="headline zoezi-edit-color">
                    {{$translate('Edit')}} {{label.toLowerCase()}}
                    <v-btn icon @click="showDialog = false" class="ml-auto zoezi-edit-color"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>

                <v-card-text class="pt-4">
                    <v-text-field :label="$translate('Settings header')" v-model="templateSettings.name" />

                    <draggable v-model="templateSettings.props">
                        <v-card v-for="(item,itemindex) in templateSettings.props" :key="item.id" elevation="2" class="mb-4 pa-2">
                            <v-row class="no-gutters v-label theme--light">
                                <v-col>
                                    {{props.find(x => x.name == item.id).title}}
                                </v-col>
                            </v-row>
                            <v-row no-gutters cols="12">
                                <v-col cols=10 class="black--text">
                                    <v-text-field v-model="item.title" :label="$translate('Title')" />
                                    <v-text-field v-model="item.hint" :label="$translate('Help text')" />
                                </v-col>
                                <v-col cols=2>
                                    <v-btn
                                        @click="removeItem(templateSettings.props, itemindex)"
                                        color="error"
                                        fab
                                        small
                                        style="margin-left: 8px"
                                    >
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </draggable>

                    <div v-if="templateSettings.props.length == 0">
                        {{$translate('No template settings have been added')}}
                    </div>

                    <v-row>
                        <v-col cols=8>
                            <v-select :label="$translate('Setting')" :items="props.filter(x => !templateSettings.props.find(p => p.id == x.name))" v-model="newProp" :item-text="item => $translate(item.title)" return-object />
                        </v-col>
                        <v-col cols=4>
                            <v-btn class="zoezi-button-thin" color="zoezi-edit-color" @click="addProp" :disabled="!newProp">{{$translate('Add')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        class="zoezi-button-thin"
                        color="zoezi-edit-color"
                        @click="save"
                        :disabled="!canSave"
                    >
                        {{$translate('Save')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';
export default {
    name: 'zoezi-component-template-settings',

    props: ['label', 'config', 'props'],

    components: {
        Draggable
    },

    watch: {
        config: {
            immediate: true,
            handler(config) {
                this.reset(config);
            }
        },
        showDialog() {
            this.reset(this.config);
        }
    },

    data: () => ({
        showDialog: false,
        templateSettings: {
            name: null,
            props: []
        },
        newProp: null
    }),

    computed: {
        canSave() {
            return this.templateSettings.props.length == 0 || this.templateSettings.name?.length;
        }
    },

    methods: {
        reset(config) {
            if (config && config.templateSettings) {
                this.templateSettings = cloneDeep(config.templateSettings);
            } else {
                this.templateSettings = {
                    name: null,
                    props: []
                }
            }
            this.newProp = null;
        },
        save() {
            let ts = cloneDeep(this.templateSettings);
            this.$set(this.config, 'templateSettings', ts);
            this.$root.saveHomePage();
            this.showDialog = false;
        },
        removeItem(array, index) {
            array.splice(index, 1)
        },
        addProp() {
            this.templateSettings.props.push({id: this.newProp.name, title: this.newProp.title, hint: ''});
            this.newProp = null;
        }
    }
}
</script>
